module.exports = __webpack_public_path__ + "img/news20-0.1337c94f.png";